// extracted by mini-css-extract-plugin
export default {"root":"PageMethod_root__AIeKa","operation":"PageMethod_operation__OwZ-l"};